import React from "react"
import { useRecoilState, useRecoilValue } from "recoil"
import { removeSnackSelector, snacksState } from "../StateSelectors"

const SNACK_TIMEOUT_MS = 6800

export interface SnackProps {
  type: "success" | "error" | "warning"
  message: string
}

export interface SnackWithIdProps {
  type: "success" | "error" | "warning"
  message: string
  id: string
}

interface SnackInternalProps extends SnackWithIdProps {
  removeSnack: (snackId: string) => void
}

export const SnackBars = (props: {}) => {
  const snacks = useRecoilValue(snacksState)
  const [, removeSnack] = useRecoilState(removeSnackSelector)
  return (
    <>
      {snacks.map((snackProps) => (
        <Snack {...snackProps} removeSnack={removeSnack} />
      ))}
    </>
  )
}

const Snack = (props: SnackInternalProps) => {
  React.useEffect(() => {
    setTimeout(function () {
      props.removeSnack(props.id)
    }, SNACK_TIMEOUT_MS)
  }, [props])

  const typeClass = props.type === "success" ? "bg-green_dark" : "warning" ? "bg-yellow_dark" : "bg-red_dark"

  return (
    <div className={`snackbar ${typeClass} show-long no-ellipsis`}>
      <label>{props.message}</label>
    </div>
  )
}
